import { Component, OnInit } from '@angular/core';
import { DocumentReference, Query, QuerySnapshot } from '@angular/fire/compat/firestore';
import { Logger } from '@app/core/logger.service';
import { FirebaseService } from '@app/shared/services/firebase.service';
import { SelectNewFileComponent } from '../select-new-file/select-new-file.component';
import { AlertController, ModalController, PopoverController } from '@ionic/angular';
const log = new Logger('ChatOptionsComponent');
@Component({
  selector: 'app-chat-options',
  templateUrl: './chat-options.component.html',
  styleUrls: ['./chat-options.component.scss'],
})
export class ChatOptionsComponent implements OnInit {
  id!: string;
  selectFile!: boolean;
  public file: File;

  constructor(
    private popoverController: PopoverController,
    private alertController: AlertController,
    private modalController: ModalController,
    private firebase: FirebaseService
  ) { }

  ngOnInit() { }

  async continueWhereItLeftOff() {
    this.popoverController.dismiss();
    const alert = await this.alertController.create({
      header: 'Continuar donde se quedó',
      message: 'El envío de chats se reanudará desde el último punto, evitando mensajes duplicados y sin necesidad de reiniciar el proceso.',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Continuar',
          handler: async () => {
            this._continueWhereItLeftOff();
          }
        }
      ]
    });
    await alert.present();
  }

  private async _continueWhereItLeftOff() {
    try {
      const query: Query<any> = this.firebase.afs.collection(`chats-batch/${this.id}/sections`).ref.where('status', '==', 'in_progress');
      const resp: QuerySnapshot<any> = await query.get();
      let _array: any[] = resp.docs.map(doc => { return { id: doc.id, ...doc.data() } });;
      if (!(resp.empty === true)) {
        if (_array && _array[0] && _array[0].id) {
          const ref = this.firebase.afs.doc(`chats-batch/${this.id}/sections/${_array[0].id}`).ref;
          await ref.update({ status: 'pending' });
          await ref.update({ status: 'in_progress' });
        }
      } else {
        this._updatePending();
      }
      log.debug(_array);
    } catch (error) {
      log.error(error);
    }
  }

  public async _updatePending() {
    try {
      const query: Query<any> = this.firebase.afs.collection(`chats-batch/${this.id}/sections`).ref.orderBy('page', 'asc');
      const resp: QuerySnapshot<any> = await query.get();
      if (!(resp.empty === true)) {
        const _array: any[] = resp.docs.map(doc => { return { id: doc.id, ...doc.data() } });
        for (const item of _array) {
          const ref = this.firebase.afs.doc(`chats-batch/${this.id}/sections/${item.id}`).ref;
          await ref.update({ status: 'pending' });
        }
        if (_array && _array[0] && _array[0].id) {
          const ref = this.firebase.afs.doc(`chats-batch/${this.id}/sections/${_array[0].id}`).ref;
          await ref.update({ status: 'in_progress' });
        }
      } else {
        this._forceResend();
      }
    } catch (error) {
      log.error(error);
    }
  }

  private async _forceResend() {
    try {
      const MAIN: string = `chats-batch`;
      const DOC: string = `${MAIN}/${this.id}`;
      const COLLECTION: string = `${MAIN}/${this.id}/sections`;
      const qDoc: DocumentReference = this.firebase.afs.doc(DOC).ref;
      const qColl: Query<any> = this.firebase.afs.collection(COLLECTION).ref;
      const rColl: QuerySnapshot<any> = await qColl.get();
      if (!(rColl.empty === true)) {
        for (let doc of rColl.docs) {
          await doc.ref.delete();
        }
      }
      const rDoc = await qDoc.get();
      const DATA: any = rDoc.data();
      await rDoc.ref.delete();
      await this.firebase.afs.collection(MAIN).add(DATA);
    } catch (error) {
      log.error(error);
    }
  }

  async selectFileAlert() {
    this.popoverController.dismiss();
    const modal = await this.modalController.create({
      component: SelectNewFileComponent,
      componentProps: { id: this.id },
    });
    await modal.present();
  }
}
